import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ApiService } from '../api/api.service';
import { BreadcrumbsService } from './breadcrumbs.service';
import { Observable } from 'rxjs';
import { IEntryJournal, IEntryJournalGrid } from 'src/rest-interfaces/IEntryJournal';
import { filter, map, tap, zip } from 'rxjs/operators';
import { IJournalCategory } from 'src/rest-interfaces/journal/IJournalCategory';

@Injectable()
export class JournalService {
  constructor(
    private API: ApiService,
    private router: Router,
    private breadcrumbsSvc: BreadcrumbsService
  ) { }

  public categories(): Observable<Array<IJournalCategory>> {
    return this.router.events.pipe(
      filter( e => e instanceof NavigationEnd )
    ).pipe(
      zip( this.API.get<Array<IJournalCategory>>( '/journal/categories' ) )
    ).pipe(
      map( d => d[ 1 ] )
    );
  }

  public feed( pagenum?: number, categoryId?: number, term?: string, loadBefore?: boolean ): Observable<Array<IEntryJournal>> {
    if (
      typeof pagenum !== 'number'
      || pagenum <= 0
    ) {
      pagenum = 1;
    }
    if (
      typeof categoryId !== 'number'
      || categoryId < 0
    ) {
      categoryId = 0;
    }

    this.breadcrumbsSvc.ApiTapper(
      {
        siteId: '1',
        title: 'Journal',
        uri: 'journal'
      }
    );
    this.breadcrumbsSvc.ApiTapper(
      {
        siteId: '2',
        title: 'Journal',
        uri: 'de/journal'
      }
    );
    this.breadcrumbsSvc.ApiTapper(
      {
        siteId: '3',
        title: 'Journal',
        uri: 'en/journal'
      }
    );

    return this.API.get<Array<IEntryJournal>>(
      '/journal/feed/'
      + ( typeof categoryId === 'number' ? 'cid' + categoryId + '/' : '' )
      + pagenum
      + ( typeof term === 'string' ? '?term=' + encodeURIComponent( term ) : '' )
      + ( typeof loadBefore === 'boolean' ? '&loadBefore=' + ( loadBefore ? '1' : '0' ) : '' )
    );
  }

  public uri( uri: string ): Observable<IEntryJournal> {
    this.breadcrumbsSvc.ApiTapper(
      {
        siteId: '1',
        title: 'Journal',
        uri: 'journal'
      }
    );
    this.breadcrumbsSvc.ApiTapper(
      {
        siteId: '2',
        title: 'Journal',
        uri: 'de/journal'
      }
    );
    this.breadcrumbsSvc.ApiTapper(
      {
        siteId: '3',
        title: 'Journal',
        uri: 'en/journal'
      }
    );

    return this.router.events.pipe(
      filter( e => e instanceof NavigationEnd )
    ).pipe(
      zip( this.API.get<IEntryJournal>( uri ) )
    ).pipe(
      map( d => d[ 1 ] )
    ).pipe(
      tap( this.breadcrumbsSvc.ApiTapper.bind( this.breadcrumbsSvc ) )
    ).pipe(
      tap( () => { window.scroll( 0, 0 ); } )
    );
  }

  // --------------------------------------------
  // Helpers

  public getStoryCategoriesStr( story: IEntryJournalGrid ): string {
    return Object.keys( story.kategorie ).map(
      cat => story.kategorie[cat].title
    ).join( ', ' );
  }
}
